export const getBase64 = async (file: Blob): Promise<string | ArrayBuffer | null> => {
  return new Promise((resolve) => {
    let baseURL: string | ArrayBuffer | null;
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      baseURL = reader.result;
      resolve(baseURL);
    };
  });
};
